// extracted by mini-css-extract-plugin
export default {"imgStyle":"ThankYouModal_imgStyle__ZSIo7","title":"ThankYouModal_title__mXbyZ","subTitle":"ThankYouModal_subTitle__dW3U2"};